import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@shared/models';
import { faBriefcase, faSuitcase, faChartLine, faWallet, faHistory } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {

  userLogado: User;
  faBriefcase = faBriefcase;
  faSuitcase = faSuitcase;
  faChartLine = faChartLine;
  faWallet = faWallet;
  faHistory = faHistory;

  routerName: String = '';
  activityRootRouter: String = "";
  activitySecundaryRouter: String = "";

  constructor(private router: Router) {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
  }

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
  }

  getRootRouter() {
    const split = this.router.url.split("/").filter(Boolean);

    if (split.length === 1) {
      this.routerName =  "Cadastro MAPV";
      this.activityRootRouter = "home";
    } else {
      const rootRouter = split[1];

      if (rootRouter === "home") {
        this.routerName = "Cadastro MAPV";
        this.activityRootRouter = "home-mapv";

      } 
      else if (rootRouter === "invasao-setor-completo") {
        this.routerName = "Invasão Setor Completo";
        this.activityRootRouter = "invasao-completo";
      } 
      else if (rootRouter === "invasao-setor-por-cidade") {
        this.routerName = "Invasão Setor Por Cidade";
        this.activityRootRouter = "invasao-cidade";
      } 
      else if (rootRouter === "historico-invasao") {
        this.routerName = "Histórico de Invasão";
        this.activityRootRouter = "historico-invasao";
      } 

      this.activitySecundaryRouter = "";

      if (split.length > 2) {
        this.getSecundaryRouter(split[2]);
      }
    }
  }

  getSecundaryRouter(router) {
    const routers = {
      "realizar-planejamento": "Realizar planejamento",
      "realizar-rateio": "Realizar rateio",
      "exibir-previsao": "Exibir previsão",
      "visao-cidade": "Visão p/ cidade",
      "acompanhamento-previsao":"Acompanhar Previsão Por Cliente",
      "acompanhar-lancamento-setor":"Acompanhar Previsão Por Setor"
    };

    this.activitySecundaryRouter = routers[router];
  }

  onActivate(event) {
    this.getRootRouter();
  }

  ngAfterViewInit(){
  }

}
